import fr from 'facet-rest';
import BaseOverride from 'Views/Page/Content/Templates/WhatIfTemplate/BaseOverride';
import { FDBodyText } from '@facet-wealth/design';

export default fr.metaOverride({ base: BaseOverride })
  .overrideAll({ hidden: true })
  .nameOverride(['primaryActionLabel'], {
    hidden: false,
    _component: () => FDBodyText,
  }, { ordinal: 200 });
